import React from "react";
import * as styles from "./skeleton-loader.css";

interface SkeletonLoaderProps {
    loading: boolean;
    children: React.ReactNode;
}

export function SkeletonLoader({ loading, children }: SkeletonLoaderProps): React.ReactElement {
    if (!loading) {
        return <>{children}</>;
    }

    return (
        <div className={styles.wrapper} aria-busy="true">
            <div className={styles.hidden}>{children}</div>
            <div className={styles.shimmer} aria-hidden="true" />
        </div>
    );
}
